import React, { useState, useEffect } from "react";
import { getAtletaPorNumero } from "./utils";
import { use } from "react";

const Court = ({
  visitorNumbers,
  homeNumbers,
  setterPosition,
  teams,
  positionHome,
  timeSacador,
  // homeLefts,
}) => {
  // const [homeLeft, setHomeLeft] = useState(false);
  const [adaptaRecebendo, setAdaptaRecebendo] = useState(false);

  // Recupera do localStorage ao montar
  useEffect(() => {
    const saved = localStorage.getItem("adaptaRecebendo");
    if (saved !== null) {
      setAdaptaRecebendo(saved === "true");
    }
  }, []);

  // Salva no localStorage sempre que mudar
  useEffect(() => {
    localStorage.setItem("adaptaRecebendo", adaptaRecebendo);
  }, [adaptaRecebendo]);

  const homeLeft = positionHome;
  const generateBalls = (team, positions, numbers, levantador) => {
    const equipe = team === "home" ? teams?.home : teams?.away;

    return positions.map((pos, index) => {
      let numero = numbers?.[index] ?? "";
      const atleta = getAtletaPorNumero(numero, equipe);
      const isLevantador = index === levantador;
      const isLibero =
        atleta?.funcao?.toLowerCase() === "líbero" ||
        atleta?.funcao?.toLowerCase() === "l";

      let bgClass = team === "home" ? "bg-blue-700" : "bg-red-700";
      let textClass = team === "home" ? "text-white" : "text-white";
      let borderClass = team === "home" ? "" : "";

      if (isLibero) {
        bgClass = "bg-white";
        textClass = "text-black";
        borderClass =
          team === "home"
            ? "border-2 border-blue-700"
            : "border-2 border-red-700";
      }

      if (isLevantador) {
        borderClass =
          team === "home" ? "border-2 border-white" : "border-2 border-white";
      }

      return (
        <div
          key={`ball-${team}-${index + 1}`}
          className={`absolute rounded-full w-8 h-8 flex items-center justify-center text-l font-bold ${bgClass} ${textClass} ${borderClass} transition-all duration-500`}
          style={{
            top: pos.top,
            left: pos.left,
          }}
          title={atleta?.nomeCompleto || ""}
        >
          {numero}
        </div>
      );
    });
  };

  const positionsL = [
    { top: "70%", left: "22%" }, //1
    { top: "70%", left: "73%" }, //2
    { top: "40%", left: "73%" }, //3
    { top: "10%", left: "73%" }, //4
    { top: "10%", left: "22%" }, //5
    { top: "40%", left: "18%" }, //6
  ];

  const positionsR = [
    { top: "10%", left: "63%" }, //1
    { top: "10%", left: "10%" }, //2
    { top: "40%", left: "10%" }, //3
    { top: "70%", left: "10%" }, //4
    { top: "70%", left: "63%" }, //5
    { top: "40%", left: "67%" }, //6
  ];

  const rightP4Recebendo = [
    { top: "0%", left: "80%" }, //1
    { top: "10%", left: "63%" }, //2
    { top: "75%", left: "30%" }, //3
    { top: "70%", left: "10%" }, //4
    { top: "70%", left: "63%" }, //5
    { top: "40%", left: "67%" }, //6
  ];
  const rightP3Recebendo = [
    { top: "10%", left: "63%" }, //1
    { top: "15%", left: "20%" }, //2
    { top: "40%", left: "10%" }, //3
    { top: "70%", left: "60%" }, //4
    { top: "40%", left: "63%" }, //5
    { top: "30%", left: "85%" }, //6
  ];

  const rightP2Recebendo = [
    { top: "10%", left: "60%" }, //1
    { top: "10%", left: "10%" }, //2
    { top: "70%", left: "60%" }, //3
    { top: "70%", left: "20%" }, //4
    { top: "60%", left: "85%" }, //5
    { top: "40%", left: "67%" }, //6
  ];

  const rightP1Recebendo = [
    { top: "0%", left: "70%" }, //1
    { top: "10%", left: "60%" }, //2
    { top: "40%", left: "20%" }, //3
    { top: "80%", left: "20%" }, //4
    { top: "70%", left: "63%" }, //5
    { top: "40%", left: "67%" }, //6
  ];
  const rightP6Recebendo = [
    { top: "10%", left: "63%" }, //1
    { top: "10%", left: "20%" }, //2
    { top: "35%", left: "5%" }, //3
    { top: "70%", left: "60%" }, //4
    { top: "40%", left: "63%" }, //5
    { top: "35%", left: "30%" }, //6
  ];

  const rightP5Recebendo = [
    { top: "10%", left: "63%" }, //1
    { top: "0%", left: "20%" }, //2
    { top: "70%", left: "55%" }, //3
    { top: "70%", left: "10%" }, //4
    { top: "55%", left: "30%" }, //5
    { top: "40%", left: "67%" }, //6
  ];

  const leftP4Recebendo = [
    { top: "75%", left: "0%" }, //1
    { top: "10%", left: "22%" }, //2
    { top: "-5%", left: "55%" }, //3
    { top: "-5%", left: "78%" }, //4
    { top: "40%", left: "18%" }, //5
    { top: "70%", left: "22%" }, //6
  ];
  const leftP3Recebendo = [
    { top: "70%", left: "25%" }, //1
    { top: "60%", left: "60%" }, //2
    { top: "40%", left: "73%" }, //3
    { top: "10%", left: "25%" }, //4
    { top: "40%", left: "18%" }, //5
    { top: "60%", left: "0%" }, //6
  ];

  const leftP2Recebendo = [
    { top: "70%", left: "22%" }, //1
    { top: "60%", left: "73%" }, //2
    { top: "10%", left: "25%" }, //3
    { top: "-5%", left: "60%" }, //4
    { top: "20%", left: "0%" }, //5
    { top: "40%", left: "18%" }, //6
  ];

  const leftP1Recebendo = [
    { top: "80%", left: "10%" }, //1
    { top: "65%", left: "25%" }, //2
    { top: "40%", left: "60%" }, //3
    { top: "0%", left: "60%" }, //4
    { top: "10%", left: "22%" }, //5
    { top: "40%", left: "18%" }, //6
  ];
  const leftP6Recebendo = [
    { top: "70%", left: "22%" }, //1
    { top: "70%", left: "50%" }, //2
    { top: "40%", left: "80%" }, //3
    { top: "10%", left: "25%" }, //4
    { top: "40%", left: "18%" }, //5
    { top: "50%", left: "60%" }, //6
  ];

  const leftP5Recebendo = [
    { top: "70%", left: "22%" }, //1
    { top: "80%", left: "60%" }, //2
    { top: "10%", left: "25%" }, //3
    { top: "0%", left: "73%" }, //4
    { top: "30%", left: "60%" }, //5
    { top: "40%", left: "18%" }, //6
  ];

  const leftRecebendo = {
    1: leftP1Recebendo,
    2: leftP2Recebendo,
    3: leftP3Recebendo,
    4: leftP4Recebendo,
    5: leftP5Recebendo,
    6: leftP6Recebendo,
  };

  const rightRecebendo = {
    1: rightP1Recebendo,
    2: rightP2Recebendo,
    3: rightP3Recebendo,
    4: rightP4Recebendo,
    5: rightP5Recebendo,
    6: rightP6Recebendo,
  };

  function getPositions({ homeLeft, timeSacador, setterPosition }) {
    // timeSacador: "a" (home) ou "b" (away)
    // setterPosition: [homeSetter, awaySetter]
    if (homeLeft) {
      if (timeSacador === "a") {
        // Home está à esquerda e awaysacando
        const pos = setterPosition[0];
        if (adaptaRecebendo) {
          return { home: leftRecebendo[pos], away: positionsR };
        } else {
          return { home: positionsL, away: positionsR };
        }
      } else {
        // Home está sacando
        const pos = setterPosition[1];

        if (adaptaRecebendo) {
          return { home: positionsL, away: rightRecebendo[pos] };
        } else {
          return { home: positionsL, away: positionsR };
        }
      }
    } else {
      if (timeSacador === "a") {
        // Home está à direita e away sacando
        const pos = setterPosition[0];
        if (adaptaRecebendo) {
          return { home: positionsL, away: rightRecebendo[pos] };
        } else {
          return { home: positionsL, away: positionsR };
        }
      } else {
        // Home está sacando
        const pos = setterPosition[1];
        if (adaptaRecebendo) {
          return { home: leftRecebendo[pos], away: positionsR };
        } else {
          return { home: positionsL, away: positionsR };
        }
      }
    }
  }

  // Lógica para pegar as posições corretas
  const { home: homePositions = [], away: awayPositions = [] } = getPositions({
    homeLeft,
    timeSacador,
    setterPosition,
  });

  // Renderização condicional: home (azul) e away (vermelho) sempre recebem seus dados,
  // mas a posição visual depende de homeLeft
  const renderCourt = () => {
    if (homeLeft) {
      return (
        <>
          <div className="absolute left-0 w-1/2 h-full p-2">
            {generateBalls(
              "home",
              homePositions,
              homeNumbers,
              setterPosition[0] - 1
            )}
          </div>
          <div className="absolute left-1/2 w-1/2 h-full p-2">
            {generateBalls(
              "away",
              awayPositions,
              visitorNumbers,
              setterPosition[1] - 1
            )}
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="absolute left-0 w-1/2 h-full p-2">
            {generateBalls(
              "away",
              homePositions,
              visitorNumbers,
              setterPosition[1] - 1
            )}
          </div>
          <div className="absolute left-1/2 w-1/2 h-full p-2">
            {generateBalls(
              "home",
              awayPositions,
              homeNumbers,
              setterPosition[0] - 1
            )}
          </div>
        </>
      );
    }
  };

  // Switch UI
  const Switch = ({ checked, onChange }) => (
    <div className="flex flex-col items-start">
      <span className="text-[8px] mr-1 mb-1 text-white font-thin">
        Posições
      </span>
      <label className="flex items-center cursor-pointer select-none">
        <div className="relative">
          <input
            type="checkbox"
            checked={checked}
            onChange={onChange}
            className="sr-only"
          />
          <div
            className={`w-6 h-2 bg-gray-300 rounded-full shadow-inner transition-colors duration-200 ${
              checked ? "bg-orange-400" : ""
            }`}
          ></div>
          <div
            className={`dot absolute w-3 h-3 bg-white rounded-full shadow -left-1 -top-0.5 transition-transform duration-200 ${
              checked ? "translate-x-6" : ""
            }`}
          ></div>
        </div>
      </label>
    </div>
  );

  return (
    <div className="relative w-[300px] h-[150px] bg-orange-300 border-2 border-white mx-auto mt-5">
      {/* Linhas de quadra */}
      <div className="absolute left-1/2 w-[57px] h-full bg-orange-400"></div>
      <div className="absolute right-1/2 w-[57px] h-full bg-orange-400"></div>
      <div className="absolute left-1/2 w-[5px] h-full bg-white"></div>

      <div className="absolute left-[89px] bottom-0 w-[3px] h-full bg-white"></div>
      <div className="absolute left-[203px] w-[3px] h-full bg-white"></div>

      <div
        className="absolute left-[89px] top-[-28px] w-[0px] h-[200px] border-l-2 border-white border-dashed pointer-events-none"
        style={{ zIndex: 0 }}
      ></div>
      <div
        className="absolute left-[203px] top-[-28px] w-[0px] h-[200px] border-l-2 border-white border-dashed pointer-events-none"
        style={{ zIndex: 0 }}
      ></div>
      {renderCourt()}
      <div className="absolute bottom-[-30px] mt-2 left-0 flex">
        <Switch
          checked={adaptaRecebendo}
          onChange={() => setAdaptaRecebendo(!adaptaRecebendo)}
        />
      </div>
    </div>
  );
};

export default Court;
